import { IStyle } from '@fluentui/react';
import { gridUnit } from '@uifabric/portal-ux/lib/styling/stylingConstants';

export interface ICredentialDialogStyles {
  main: IStyle;
  content: IStyle;
  description: IStyle;
  image: IStyle;
  imageSection: IStyle;
  centeredText: IStyle;
}

export const styles: ICredentialDialogStyles = {
  main: {
    maxWidth: '560px !important',
  },
  content: {
    paddingLeft: gridUnit * 4,
    paddingRight: gridUnit * 4,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    gap: gridUnit * 3,
  },
  description: { fontWeight: 600 },
  imageSection: { display: 'flex', flexFlow: 'column', alignItems: 'center', gap: gridUnit * 1.5 },
  image: { width: '150px', height: '150px' },
  centeredText: { 'text-align': 'center'}
};
